const initState = {
    booleanPublishCourseModalInitialIsOpen: false,
    booleanPublishCourseModalFinalIsOpen: false,
    courseObject: 'unselected',
    StateOfForm: 'closed',
    selectedCourse: '',

};

const publishCourseReducer = (state=initState, action) => {
    
    switch (action.type) {



        case 'DISPLAY_PUBLISH_COURSE_MODAL':
            return {
                ...state,
                booleanPublishCourseModalInitialIsOpen: action.booleanPublishCourseModalInitialIsOpen,
                booleanPublishCourseModalFinalIsOpen: action.booleanPublishCourseModalFinalIsOpen,
                courseObject: action.courseObject,
            }

        case 'PUBLISH_COURSE_ACTION':
            return {
                ...state,

            }

        case 'PUBLISH_COURSE_ACTION_ERROR':
            return{
                ...state,
            }


        default:
            return state;
           
    }

}



export default publishCourseReducer

